module.exports = __webpack_public_path__ + "img/lauberganggelaender.8f651a55.webp";